import React, { useState } from "react";
import { Button } from "react-bootstrap";

const ProveedorSelector = ({
  value,
  onChange,
  filter,
  proveedores,
  onCrearNuevo,
  modoNuevo,
  onModoNuevoChange,
  nuevoNombre,
  onNuevoNombreChange,
  nuevoRut,
  onNuevoRutChange,
  hintCreacion,
}) => {
  const [busqueda, setBusqueda] = useState("");

  const filtrados = proveedores
    .filter((p) => (filter ? filter(p) : true))
    .filter((p) => {
      if (!busqueda) return true;
      const t = busqueda.toLowerCase();
      return (
        (p.nombre || "").toLowerCase().includes(t) ||
        (p.alias || "").toLowerCase().includes(t) ||
        (p.rut_ruc || "").toLowerCase().includes(t)
      );
    });

  return (
    <>
      <div style={{ fontSize: "0.82rem", fontWeight: 600, marginBottom: 6 }}>Proveedor</div>
      {!modoNuevo ? (
        <>
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Buscar proveedor..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            style={{ marginBottom: 6 }}
          />
          <div
            style={{
              maxHeight: 140,
              overflowY: "auto",
              border: "1px solid #dee2e6",
              borderRadius: 4,
              marginBottom: 8,
            }}
          >
            {filtrados.length === 0 ? (
              <div style={{ padding: 12, textAlign: "center", color: "#999", fontSize: "0.82rem" }}>
                Sin proveedores
              </div>
            ) : (
              filtrados.map((p) => {
                const sel = value === p.id;
                return (
                  <div
                    key={p.id}
                    onClick={() => onChange(p)}
                    style={{
                      padding: "6px 12px",
                      cursor: "pointer",
                      fontSize: "0.82rem",
                      borderBottom: "1px solid #f0f0f0",
                      background: sel ? "#e8f4fd" : "transparent",
                      fontWeight: sel ? 600 : 400,
                    }}
                  >
                    {p.nombre}
                  </div>
                );
              })
            )}
          </div>
          {onModoNuevoChange && (
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={() => (onCrearNuevo ? onCrearNuevo() : onModoNuevoChange(true))}
              style={{ marginBottom: 14, fontSize: "0.78rem" }}
            >
              + Nuevo proveedor
            </Button>
          )}
        </>
      ) : (
        <div
          style={{
            border: "1px solid #dee2e6",
            borderRadius: 4,
            padding: 10,
            marginBottom: 14,
            background: "#fafbfc",
          }}
        >
          <div style={{ display: "flex", gap: 8, marginBottom: 6 }}>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Nombre del proveedor"
              value={nuevoNombre}
              onChange={(e) => onNuevoNombreChange(e.target.value)}
              style={{ flex: 2, fontSize: "0.82rem" }}
            />
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="RUT/Tax ID (opcional)"
              value={nuevoRut}
              onChange={(e) => onNuevoRutChange(e.target.value)}
              style={{ flex: 1, fontSize: "0.82rem" }}
            />
          </div>
          {hintCreacion && <div style={{ fontSize: "0.72rem", color: "#666", marginBottom: 6 }}>{hintCreacion}</div>}
          <Button
            size="sm"
            variant="outline-secondary"
            onClick={() => {
              onModoNuevoChange(false);
              onNuevoNombreChange("");
              onNuevoRutChange("");
            }}
            style={{ fontSize: "0.78rem" }}
          >
            Cancelar
          </Button>
        </div>
      )}
    </>
  );
};

export default ProveedorSelector;
